import React from "react";
import "./Loader.css";

const Loader = () => (
  <div className="loader-container">
    <span className="loader"></span>
  </div>
);

export default Loader;
